<template>
  <v-card rounded class="pa-7 tournament-reg-card" outlined>
    <v-container fluid>
      <div class="d-flex justify-center">
        <v-img class="mb-5" position="center center"
          src="https://hub.swiset.com/wp-content/uploads/2021/01/Tournaments-Ranking-Swiset.png" max-width="70px" contain />
      </div>
      <h1 class="text-center">{{ $t('title_TournamentRegisterCollapsed') }}</h1>
      <div v-if="false">
        <p class="text-center mb-10 mt-2">{{ $t('descriptionLink') }}</p>
        <a :href="$store.state.tournament.faqsUrl" target="_blank" class="d-flex align-center justify-center">
          <p :style="`color: ${$store.state.tournament.tournamentSettings?.colors?.primary ? '#' + $store.state.tournament.tournamentSettings.colors.primary.replace('#', '') : '#000'}`" class="text-center">{{
            $store.state.tournament.faqsUrl }}</p>
        </a>
      </div>

      <div v-else-if="verifiedAccounts.length > 0">
        <p class="text-center mb-10 mt-2">{{ $t('description_TournamentRegisterCollapsed') }}<br>{{ hasConstraint ? $t('constraint') : '' }}</p>
        <v-select :items="verifiedAccounts" item-value="id" item-text="identifier" :label="$t('label')"
          :placeholder="$t('placeholder')" v-model="accountSelected" outlined />
        <v-btn v-if="this.accountSelected !== 0" style="width: 100%" class="button-register"
          @click="registerParticipant">
          {{ forUpdateAcc ? $t('btnUpdate') :  $t('btnRegister') }}
        </v-btn>
        <p v-if="this.accountSelected !== 0 && !forUpdateAcc" style="font-size: 14px; color: #5a5a5a" class="text-center mb-n1 mt-3">{{
          $t('registering') }}
          <a v-if="!forUpdateAcc" style="font-size: 14px; color: #5a5a5a" href="https://swiset.com/competitions/terms-and-conditions" target="_blank">{{
            $t('termsAndConditions') }}</a>.
        </p>
      </div>
      <p v-else-if="mandatoryPartner !== null" class="text-center mb-7 mt-2"
        v-html="$t('notVerifiedAndMandatoryPartner', { partner: mandatoryPartner.short_name, ibUrl: mandatoryPartner.website_url })" />
      <p v-else-if="hasConstraint">
        {{ $t('notFullfilConstraint') }}
      </p>
      <p v-else class="text-center mb-7 mt-2" v-html="$t('notVerified')" />
    </v-container>
  </v-card>
</template>

<script>
import Repository from '../../../repositories/tournament';
import PartnerRepository from '../../../repositories/partner';
import { mapMutations } from 'vuex';
export default {
  name: "TournamentRegisterCollapsed",
  props: {
    forUpdateAcc: Boolean,
    participantData: Object,
    hideModal: Function
  },
  data() {
    return {
      verifiedAccounts: [],
      accountSelected: 0,
      mandatoryPartner: null,
      hasConstraint: false,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      this.hasConstraint = this.$store.state.tournament.tournamentSettings.restrictedAccountType == 'LIVE';
      this.verifiedAccounts = !this.hasConstraint ? this.$store.state.user.brokerAccounts.filter((account) => account.verified) : this.$store.state.user.brokerAccounts.filter((account) => account.verified && account.type === 'LIVE');
      this.mandatoryPartner = this.$store.state.tournament.tournamentSettings.mandatoryPartner || this.$store.state.tournament.mandatoryPartner;
      if (this.mandatoryPartner && this.mandatoryPartner !== null){
         await PartnerRepository.getBrokersByPartner(this.mandatoryPartner.id).then((brokersFromPartner) => {
          if(brokersFromPartner.status < 400){
            this.verifiedAccounts = this.verifiedAccounts.filter((account) => brokersFromPartner.data.find((broker) => broker.id === account.broker.id));
          }
        });
      }
    },
    ...mapMutations(['setTournament']),
    registerParticipant() {
      if (this.forUpdateAcc) {
        this.updateBrokerAcc();
      } else {
        let tournamentParticipant = {
          tournament: { id: this.$store.state.tournament.tournamentId },
          assignedAccount: { id: this.accountSelected },
          user: { id: this.$store.state.user.id },
        };

        Repository.enrollParticipant(tournamentParticipant).then((response) => {
          if (response.status < 400) {
            alert(`Congrats! You were successfully register to the tournament.`);
            Repository.getTournamentOverview(this.$store.state.tournament.tournamentId).then((secondResponse) => {
              if (secondResponse.status < 400)
                this.setTournament(secondResponse.data);
            });
          }
        });
      }
    },
    updateBrokerAcc() {
      Repository.updateParticipantBrokerAccount(
        this.participantData.participantId,
        this.accountSelected
      ).then((res) => {
        if (res.status < 400) {
          this.hideModal();
          setTimeout(()=>{
            this.$router.go();
          },1e3);
        }
      });
    }
  }
}
</script>



<style>
.tournament-reg-card {
  background-color: var(--v-mainWhite-base) !important;
  color: var(--v-mainBlack-base) !important;
}
</style>
